export interface MemberNickname {
    id: string;
    teamId: string;
    viewerId: string;
    targetId: string;
    nickname: string;
    createdAt: string;
}

export const dbRowToMemberNickname = (row: any): MemberNickname => ({
    id: row.id,
    teamId: row.team_id,
    viewerId: row.viewer_id,
    targetId: row.target_id,
    nickname: row.nickname,
    createdAt: row.created_at,
});
